import { Link } from 'react-router-dom';

const reasons = [
  {
    icon: 'ri-flask-line',
    title: '自有研發團隊',
    desc: '專業團隊提供完整研發支援',
  },
  {
    icon: 'ri-verified-badge-line',
    title: '國際認證廠房',
    desc: '擁有國際相關食品安全認證，嚴格把關生產，品質有保障',
  },
  {
    icon: 'ri-global-line',
    title: '把控法規細節',
    desc: '熟悉相關法規，為客戶打造低風險的爆款產品',
  },
  {
    icon: 'ri-time-line',
    title: '快速交期',
    desc: '完善生產排程，有效縮短整體合作流程',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '專屬業務服務',
    desc: '專業業務人員，從諮詢到出貨全程陪伴支援',
  },
  {
    icon: 'ri-leaf-line',
    title: '天然原料優先',
    desc: '嚴選優質天然原料，為客戶打造真正天然營養高品質的保健產品',
  },
];

export default function AboutWhySection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          {/* Left */}
          <div className="w-full lg:w-2/5 flex-shrink-0">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
              選擇康永
            </span>
            <h2 className="text-[#1a2e1a] font-bold leading-tight mb-6">
              為什麼超過 250 個<br />品牌選擇我們？
            </h2>
            <p className="text-gray-500 text-[1.0625rem] leading-[1.75] mb-8">
              我們不只是代工廠，更是協助品牌成功的策略夥伴。從產品開發到市場上市，康永提供全程專業支援。
            </p>
            <Link
              to="/contact/form"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-7 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              立即諮詢
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Right - grid */}
          <div className="w-full lg:w-3/5">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {reasons.map((r) => (
                <div key={r.title} className="bg-white rounded-xl p-5 flex gap-4 border border-gray-100 hover:border-green-200 transition-all duration-300">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-50 rounded-xl flex-shrink-0">
                    <i className={`${r.icon} text-[#4CAF50] text-xl`} />
                  </div>
                  <div>
                    <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-1">{r.title}</h3>
                    <p className="text-gray-500 text-[0.875rem] leading-[1.75]">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}